import React, { useState } from 'react';
import { CheckCircle2, Loader2, RefreshCw, Send, SwitchCamera } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { LiveSelfieCamera } from '@/components/staffAttendance/LiveSelfieCamera';

/** Live in-app selfie (+ head-turn when liveness is on): Capture → Retake / Submit. No gallery. */
export const SelfieStep = ({ busy, onSubmit, onCancel, submitLabel = 'Submit', big = false, allowSwitch = false, liveness = false, testId = 'att-selfie' }) => {
  const [shot, setShot] = useState(null);
  const [facing, setFacing] = useState('user');
  const btn = big ? 'h-16 text-xl px-8 rounded-2xl' : 'h-11';
  return (
    <div className="space-y-3" data-testid={testId}>
      {shot ? (
        <>
          <img src={shot.selfie} alt="selfie" className="w-full max-h-[55vh] object-contain rounded-2xl bg-black" data-testid={`${testId}-preview`} />
          {shot.liveness && <div className="flex items-center justify-center gap-1 text-sm text-emerald-600" data-testid={`${testId}-turn-ok`}><CheckCircle2 className="w-4 h-4" />Head turn recorded</div>}
        </>
      ) : (
        <LiveSelfieCamera liveness={liveness} facing={facing} onDone={(selfie, live) => setShot({ selfie, liveness: live })} onCancel={onCancel} testId={`${testId}-camera`} />
      )}
      <div className="flex flex-wrap gap-3 justify-center">
        {!shot && allowSwitch && (
          <Button type="button" variant="outline" className={btn} onClick={() => setFacing((f) => (f === 'user' ? 'environment' : 'user'))} data-testid={`${testId}-switch`}>
            <SwitchCamera className="w-5 h-5 mr-2" />Switch camera
          </Button>
        )}
        {shot && (
          <Button type="button" variant="outline" className={btn} onClick={() => setShot(null)} disabled={busy} data-testid={`${testId}-retake`}>
            <RefreshCw className="w-5 h-5 mr-2" />Retake
          </Button>
        )}
        {shot && (
          <Button type="button" className={`${btn} bg-emerald-600 hover:bg-emerald-700`} onClick={() => onSubmit(shot.selfie, shot.liveness)} disabled={busy} data-testid={`${testId}-submit`}>
            {busy ? <Loader2 className="w-5 h-5 mr-2 animate-spin" /> : <Send className="w-5 h-5 mr-2" />}{submitLabel}
          </Button>
        )}
      </div>
    </div>
  );
};

export default SelfieStep;
